import React, { useEffect,  useState } from 'react';
import { TabbedPage, Tab } from 'components/Shared/TabbedPage';
import ChecklistDetailsDisplay from './ChecklistDetailsDisplay';
import ChecklistArtifactsDisplay from './ChecklistArtifactsDisplay';
import { downloadChecklistForm } from 'utils/ProjectConfigurationUtil'

const tabs = [
  new Tab({ label: "Edit", value: "Details" }),
  new Tab({ label: "Artifacts", value: "Artifacts" })
]

const ChecklistDetails = ({ checklistItem,callback }) => {
  const [activeTab, setActiveTab] = useState('Details');
  const [details, setDetails] = useState(checklistItem);

  useEffect(() => {
    async function anyNameFunction() {
      const download =  await downloadChecklistForm(details.ChecklistFormId)
      checklistItem.URL = download.url;
      setDetails(checklistItem)
      console.log(download)
    }

    anyNameFunction();
},[details])

  return (
    <TabbedPage
      tabs={tabs}
      activeTab={activeTab}
      tabSetterFunc={setActiveTab}
    >
      {activeTab === "Details" ? <ChecklistDetailsDisplay key={1} defaultValues={details} loaded={!!details} CRUDType={"UPDATE"} callback={callback}/> : <ChecklistArtifactsDisplay artifact={details} />}
    </TabbedPage>
  )
}

export default ChecklistDetails;